<template>
  <v-dialog
    v-model="dialog"
    width="400"
    persistent
  >
    <v-card
      class=""
      flat
      tile
    >
      <v-toolbar
        color="light-blue darken-2"
        flat
        dense
      >
        <v-toolbar-title class="white--text">
          {{ $t('m.login') }}
        </v-toolbar-title>
      </v-toolbar> <!-- end toolbar -->

      <v-container fluid>
        <v-card
          class="px-6"
          flat
          tile
        >
          <div class="text-center py-4">
            <img
              src="../assets/portdistancelogo.png"
              style="width:260px;"
              alt=""
            >
          </div>

          <v-form
            fluid
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              large
              v-model="email"
              :label="$t('m.email')"
              prepend-icon="mdi-email-outline"
              required
            />

            <v-text-field
              v-model="password"
              :label="$t('m.password')"
              prepend-icon="mdi-lock-outline"
              required
              :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
              :type="passwordShow ? 'text' : 'password'"
              @click:append="passwordShow = !passwordShow"
            />

            <v-btn
              block
              class="mt-4"
              depressed
              :loading="loading"
              :disabled="loading || !valid"
              color="success"
              @click="onSubmit"
            >
              {{ $t('m.signin') }}
            </v-btn>
          </v-form>

          <template v-if="$i18n.locale=='zh-CN'">
            <v-card
              class="d-flex mt-3"
              flat
              tile
            >
              <v-btn
                text
                middle
                color="grey darken-1"
                @click="routeToFogot"
              >
                {{ $t('m.forgetPassword') }}
              </v-btn>
              <v-spacer />
              <v-btn
                text
                middle
                color="primary"
                @click="routeToSignup"
              >
                {{ $t('m.createAccount') }}
              </v-btn>
            </v-card>
          </template>
          <template v-else>
            <v-card
              class="mt-3 text-center"
              flat
              tile
            >
              <v-btn
                text
                middle
                color="grey darken-1"
                @click="routeToFogot"
              >
                {{ $t('m.forgetPassword') }}
              </v-btn>
              <v-btn
                text
                middle
                color="primary"
                @click="routeToSignup"
              >
                {{ $t('m.createAccount') }}
              </v-btn>
            </v-card>
          </template>
        </v-card>

        <div
          class=""
          style="height:0; overflow-y:auto;"
        >
          {{ errorInfo }}
        </div>
      </v-container> <!-- end workspace -->

      <v-card
        class=""
        flat
        tile
      />

      <v-snackbar
        app
        centered
        absolute
        bottom
        v-model="errorSnackbar"
      >
        {{ $t('m.errorLogin') }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="errorSnackbar = false"
          >
            {{ $t('m.close') }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-card> <!-- end 最外层card -->

    <SignUpDialog
      :visible="signUpDlgVisible"
      @cancel="cancelSignUp"
      @save="handleSignUpSuccess"
    />

    <PasswdForgotDialog
      :visible="forgotDlgVisible"
      @cancel="cancelForgot"
      @save="handleSignUpSuccess"
    />

    <v-snackbar
      v-model="successSnackbar"
      color="blue-grey"
      absolute
      top
      timeout="2000"
      rounded="pill"
    >
      {{ successSnackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="successSnackbar = false"
        >
          CLOSE
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import httpClient from '@/api/httpClient'
import Utils from '@/utils/index'
import Constant from '@/constant/index'

import SignUpDialog from '@/views/SignUpDialog'
import PasswdForgotDialog from '@/views/PasswdForgotDialog'

export default {
  name: 'LoginDialog',
  components: {
    SignUpDialog, PasswdForgotDialog
  },
  props: [
    'visible'
  ],
  data: () => ({
    dialog: false,

    valid: true,
    loading: false,
    passwordShow: false,
    password: '',
    email: '',
    errorSnackbar: false,
    alert: false,
    errorInfo: null,

    successSnackbar: false,
    successSnackbarText: null,
    signUpDlgVisible: false,
    forgotDlgVisible: false
  }),

  created () {
    var operID = Utils.getWithExpiry('operID')
    if (!operID) {
      this.dialog = true
    } else {
      this.$store.commit('setUserOnline', true)
    }
  },

  watch: {
    visible: function (val) {
      this.dialog = val
    }
  },

  methods: {
    onSubmit () {
      if (!this.email || !this.email.trim() ||
          !this.password || !this.password.trim()) {
        return
      }
      this.loading = true
      var postJson = {
        OperID: this.email,
        OperPassword: this.password
      }
      // 910260941@qq.com jy55213305 CordovaWebView  OPWebAppLoginForPortdistance
      // /usr/local/lib/node_modules/cordova/node_modules/objectorarray/package.json
      httpClient.post('/auth/OPWebAppLoginForCircular', postJson)
        .then((res) => {
          console.log(res)
          this.loading = false
          if (res.data.error) {
            this.errorSnackbar = true
          } else if (res.data.message) {
            Utils.setWithExpiry('operID', res.data.message.operID, Constant.LOCALSTORAGE_EXPIRY_PERIOD)
            Utils.setWithExpiry('operName', res.data.message.operName, Constant.LOCALSTORAGE_EXPIRY_PERIOD)
            Utils.setWithExpiry('token', res.data.message.token, Constant.LOCALSTORAGE_EXPIRY_PERIOD)
            Utils.setWithExpiry('accessCode', res.data.message.accessCode, Constant.LOCALSTORAGE_EXPIRY_PERIOD)
            this.$store.commit('setUserOnline', true)
            this.$store.commit('setUserLogoutClearFlag', false)

            this.passwordShow = false,
            this.password = ''
            this.dialog = false

            this.$emit('close')
          }
        }).catch((err) => {
          this.loading = false
        })
    }, // end onSubmit

    routeToSignup () {
      this.signUpDlgVisible = true
    },
    cancelSignUp () {
      this.signUpDlgVisible = false
    },

    handleSignUpSuccess (email) {
      this.signUpDlgVisible = false
      this.email = email
      this.successSnackbarText = this.$t('m.signupSuccess')
      this.successSnackbar = true
    },

    routeToFogot () {
      this.forgotDlgVisible = true
    },
    cancelForgot () {
      this.forgotDlgVisible = false
    }
  }
}
</script>
